import { StorageKey, setSessionStorage } from '@utils/StorageUtils';
import { SellerInsightsRetailerClientState } from '../../reducers/seller-insights-retailer-client/SellerInsightsRetailerClientReducer';
import { SellerInsightsRetailerClientTypes } from '../Type';

export const updateSellerInsightsRetailerClient = (payload: SellerInsightsRetailerClientState) => {
  return (dispatch: any) => {
    dispatch({
      type: SellerInsightsRetailerClientTypes.SellerInsightsRetailerClientUpdate,
      payload,
    });
    setSessionStorage(StorageKey.SellerInsightsRetailerClient, JSON.stringify(payload));
  };
};
